<template>
  <default-modal name="success-modal" v-model="modalOpened">
    <div slot="content" class="text-center">
      <check-mark></check-mark>
      <h3>{{ title }}</h3>
      <p v-if="body">{{ body }}</p>
    </div>
  </default-modal>
</template>

<script>
  import CheckMark from 'components/Common/Animations/Checkmark.vue'
  import DefaultModal from 'components/Modal/DefaultModal.vue'

  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      body: {
        type: String
      }
    },

    data () {
      return {
        modalOpened: false
      }
    },

    methods: {
      open () {
        this.modalOpened = true
      },

      close () {
        this.modalOpened = false
      }
    },

    components: {
      CheckMark,
      DefaultModal
    }
  }
</script>
